// Generated by `yarn tokens:import --aos-ds` from the Figma "Actions" icon section.
// Do not edit.
//
// Colour is not here on purpose: every path renders `currentColor`, so an icon
// takes its ink from `tone` like the rest of the package. The size is the one
// Figma draws at — the section holds 24px glyphs and 52px pictograms, and
// picking one for the other is not a decision this package makes.

import type { FigmaGlyph } from './glyph'

export const Plus: FigmaGlyph = {
    name: 'Plus',
    nodeId: '46:1386',
    width: 24,
    height: 24,
    paths: [
        {
            d: 'M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        },
    ],
}
